import { useEffect, useState } from "react";
import { GooglePlayButton, AppStoreButton } from "react-mobile-app-button";
import { getAnalytics, logEvent } from "firebase/analytics";
import { app } from "../../firebase-config";
import styles from "./OpenApp.module.css";

const OpenApp = () => {
  const [platform, setPlatform] = useState("desktop");
  const [appOpened, setAppOpened] = useState(false);

  const analytics = getAnalytics(app);

  const IOS_STORE = "https://apps.apple.com/us/app/qwytt-nicotine/id6657960125";
  const ANDROID_STORE = "https://play.google.com/store/apps/details?id=com.qwytt.nicotine.prod";
  const APP_SCHEME = "qwytt://";

  useEffect(() => {
    // Detect platform
    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isAndroid = /android/.test(ua);

    if (isIOS) {
      setPlatform("ios");
    } else if (isAndroid) {
      setPlatform("android");
    } else {
      setPlatform("desktop");
    }

    // Get UTM params for analytics
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source") || "direct";
    const utmMedium = params.get("utm_medium") || "none";
    const utmCampaign = params.get("utm_campaign") || "none";

    // Log page view
    logEvent(analytics, "open_app_page_view", {
      platform: isIOS ? "ios" : isAndroid ? "android" : "desktop",
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
    });

    // On mobile, try to open the app
    if (isIOS || isAndroid) {
      tryOpenApp();
    }
  }, [analytics]);

  const tryOpenApp = () => {
    // Try to open the app via custom URL scheme
    const start = Date.now();

    window.location.href = APP_SCHEME;

    // Check if we're still on the page after a delay
    // If we are, the app probably isn't installed
    setTimeout(() => {
      if (Date.now() - start < 2000) {
        // App likely opened, but we can't know for sure
        setAppOpened(true);
      }
    }, 1500);
  };

  const handleStoreClick = (store) => {
    logEvent(analytics, "store_click", {
      store: store,
      platform: platform,
      page: "open_app",
    });
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.logo}>Qwytt</div>

        {platform !== "desktop" && !appOpened && (
          <div className={styles.loading}>
            <div className={styles.spinner}></div>
            <h1 className={styles.title}>Opening Qwytt...</h1>
            <p className={styles.subtitle}>
              If the app doesn't open, download it below.
            </p>
          </div>
        )}

        {platform === "desktop" && (
          <div className={styles.desktopMessage}>
            <h1 className={styles.title}>Get the Qwytt App</h1>
            <p className={styles.subtitle}>
              Download on your phone to start tracking.
            </p>
          </div>
        )}

        <div className={styles.storeButtons}>
          {(platform === "ios" || platform === "desktop") && (
            <div onClick={() => handleStoreClick("ios")}>
              <AppStoreButton url={IOS_STORE} theme="dark" />
            </div>
          )}

          {(platform === "android" || platform === "desktop") && (
            <div onClick={() => handleStoreClick("android")}>
              <GooglePlayButton url={ANDROID_STORE} theme="dark" />
            </div>
          )}
        </div>

        <a href="/" className={styles.webLink}>
          or continue to qwytt.com →
        </a>

        <div className={styles.footer}>
          <p>
            Questions? <a href="mailto:contact@qwytt.ai">contact@qwytt.ai</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OpenApp;